import React from 'react'
import {connect} from 'react-redux'

class ArenaEnvironmentBackground extends React.Component {

  getMobileStyle() {
    return {
      top: this.props.vH * -4,
      right:0,
      bottom:0,
      backgroundSize: this.props.vW * 210,
    }
  }

  getDesktopStyle() {
    return {
      right:0,
      bottom:0,
      top: 0,
      backgroundSize: '100%',
    }
  }

  render() {

    const viewportModeStyles = this.props.viewportMode === "portrait"
      ? this.getMobileStyle()
      : this.getDesktopStyle();

    const style = {
      position: 'absolute',

      //NOTE: the gradient overlay is now a psuedo on the class
      background: `url(/images/arenas/indoor-map-with-objects.svg) no-repeat, #687991`,
      //hex color at the end should be dynamic to the map that is loaded?


      left:0,
      ...viewportModeStyles,

    };

    return (
      <div className="ArenaEnvironmentBackground" style={style} />
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    vH: state.global.vH,
    // vH: state.global.vW,
    viewportMode: state.global.viewportMode,
  }
})(ArenaEnvironmentBackground)


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaEnvironmentBackground.js